import { apiRequest } from "./backendApi";

export type LangfuseDatasetRow = {
  id: string;
  name: string;
  description?: string | null;
  metadata?: Record<string, unknown> | null;
  createdAt?: string;
  updatedAt?: string;
  projectId?: string;
};

export type DatasetsListResponse = {
  data: LangfuseDatasetRow[];
  meta?: {
    page?: number;
    limit?: number;
    totalItems?: number;
    totalPages?: number;
  };
};

export type AgentDatasetPair = {
  agent_id: string;
  dataset_id: string;
  dataset_name: string | null;
  nightly: boolean;
  created_at: string;
  updated_at: string;
};

export type PairsListResponse = {
  data: AgentDatasetPair[];
  count: number;
};

export const datasetCoverageApi = {
  async listPairs(): Promise<PairsListResponse> {
    return apiRequest<PairsListResponse>("GET", "/api/pairs");
  },

  async listDatasets(query?: { page?: number; limit?: number }): Promise<DatasetsListResponse> {
    return apiRequest<DatasetsListResponse>("GET", "/api/datasets", { query });
  },

  async listPairsForAgent(agentId: string): Promise<PairsListResponse> {
    return apiRequest<PairsListResponse>("GET", "/api/pairs", { query: { agent_id: agentId } });
  },

  async connectPair(input: {
    agent_id: string;
    dataset_id: string;
    dataset_name?: string | null;
    nightly: boolean;
  }): Promise<AgentDatasetPair> {
    return apiRequest<AgentDatasetPair>("POST", "/api/pairs/connect", { body: input });
  },

  async removePair(agentId: string, datasetId: string): Promise<void> {
    await apiRequest<{ removed: true }>("POST", "/api/pairs/remove", {
      body: { agent_id: agentId, dataset_id: datasetId },
    });
  },
};
